import { IRequestOptions } from '@services/method';

export const formatPostRequest = (
  options: any,
  headers: any
): IRequestOptions => {
  const params = JSON.stringify({
    ...options,
  });

  return {
    init: {
      body: params,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    },
  };
};
